import { render, staticRenderFns } from "./RawPesistuloksetAnalysis.vue?vue&type=template&id=daada18c&scoped=true"
import script from "./RawPesistuloksetAnalysis.vue?vue&type=script&lang=js"
export * from "./RawPesistuloksetAnalysis.vue?vue&type=script&lang=js"
import style0 from "./RawPesistuloksetAnalysis.vue?vue&type=style&index=0&id=daada18c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "daada18c",
  null
  
)

export default component.exports